import { A4uCheckmark as IconComponent } from '@adobe/react-spectrum-workflow/dist/Checkmark.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function Checkmark(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}